module.exports = __webpack_public_path__ + "img/library-vlog-zh.7601de92.webp";